import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Skeleton component for MobileHeaderBar
 * Matches the exact structure of the real header
 */
export const MobileHeaderBarSkeleton = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[40]" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
      <div className="bg-background border-b border-border shadow-sm px-4 py-3 flex items-center justify-between">
        {/* Menu Button Skeleton */}
        <Skeleton 
          variant="default" 
          shimmer 
          className={cn(
            "h-8 w-8 rounded-lg min-h-[44px] min-w-[44px]"
          )}
        />

        {/* Center: Page Name Display Skeleton */}
        <div className="flex items-center gap-1 flex-1 justify-center px-1 min-w-0">
          <Skeleton variant="soft" shimmer className="h-4 w-4 rounded flex-shrink-0" />
          <Skeleton variant="default" shimmer className="h-3 w-24 rounded" />
        </div>

        {/* Chat Button Skeleton */}
        <Skeleton 
          variant="default" 
          shimmer 
          className={cn(
            "h-8 w-8 rounded-lg min-w-[44px] min-h-[44px]"
          )}
        />
      </div>
    </div>
  );
};
